var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7338 4.98505L8.79775 2.11658C8.60277 1.97449 8.3161 1.88493 7.9994 1.88493C7.68271 1.88493 7.39604 1.97449 7.20106 2.11658L3.26518 4.9849L7.20128 7.85337C7.39625 7.99547 7.68293 8.08502 7.99962 8.08502C8.31631 8.08502 8.60299 7.99547 8.79796 7.85337L12.7338 4.98505ZM1.95158 4.2965L6.41775 1.04172C6.87999 0.704855 7.45471 0.554932 7.9994 0.554932C8.5441 0.554932 9.11882 0.704854 9.58106 1.04172L14.0409 4.29186C14.6161 4.64311 15 5.27672 15 6V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V6C1 5.27989 1.38058 4.64866 1.95158 4.2965ZM2.33 6C2.33 5.98332 2.33061 5.96677 2.33181 5.9504L6.41796 8.92823C6.88021 9.2651 7.45492 9.41502 7.99962 9.41502C8.54432 9.41502 9.11903 9.2651 9.58128 8.92823L13.6682 5.94987C13.6694 5.96642 13.67 5.98314 13.67 6V12C13.67 12.37 13.37 12.67 13 12.67H3C2.62997 12.67 2.33 12.37 2.33 12V6Z",
    fill: "#37A4F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaded);
export default __webpack_public_path__ + "static/media/readed.aaa7291d74be88f140ca01f8ff1f9881.svg";
export { ForwardRef as ReactComponent };